const swiperHpCollection = new Swiper(".swiper-collection", {
  // Optional parameters
  loop: true,
  slidesPerView: "auto",
  slidesPerGroup: 1,
  spaceBetween: 14,

  breakpoints: {
    768: {
      slidesPerView: 4,
      slidesPerGroup: 1,
      spaceBetween: 20,
    },
  },

  // If we need pagination
  //   pagination: {
  //     el: ".swiper-pagination",
  //   },

  //   Navigation arrows
  navigation: {
    nextEl: ".swiper-next",
    prevEl: ".swiper-prev",
  },
});
